var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3691_3645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6371 0.207067C13.452 0.0724884 13.229 0 13.0001 0C12.7713 0 12.5483 0.0724884 12.3631 0.207067L0.44646 8.87373C0.21402 9.04268 0.0582119 9.29704 0.0133126 9.58086C-0.0315867 9.86468 0.0381002 10.1547 0.207043 10.3872C0.375986 10.6196 0.630346 10.7754 0.914167 10.8203C1.19799 10.8652 1.48802 10.7955 1.72046 10.6266L2.16679 10.3016V22.7502C2.16679 23.6121 2.5092 24.4388 3.1187 25.0482C3.72819 25.6577 4.55484 26.0002 5.41679 26.0002H20.5835C21.4454 26.0002 22.2721 25.6577 22.8816 25.0482C23.4911 24.4388 23.8335 23.6121 23.8335 22.7502V10.3016L24.2798 10.6266C24.3949 10.7102 24.5253 10.7704 24.6637 10.8036C24.802 10.8369 24.9456 10.8425 25.0861 10.8203C25.2266 10.7981 25.3614 10.7484 25.4827 10.6741C25.6041 10.5997 25.7096 10.5022 25.7932 10.3872C25.8769 10.2721 25.937 10.1416 25.9703 10.0033C26.0035 9.86493 26.0092 9.72139 25.9869 9.58086C25.9647 9.44032 25.915 9.30555 25.8407 9.18422C25.7664 9.06289 25.6689 8.95739 25.5538 8.87373L13.6371 0.207067ZM10.8335 23.8335V15.1668H15.1668V23.8335H10.8335ZM21.6668 22.7502C21.6668 23.0375 21.5527 23.313 21.3495 23.5162C21.1463 23.7193 20.8708 23.8335 20.5835 23.8335H17.3335V15.1668C17.3335 14.5922 17.1052 14.0411 16.6989 13.6348C16.2925 13.2284 15.7414 13.0002 15.1668 13.0002H10.8335C10.2588 13.0002 9.70772 13.2284 9.3014 13.6348C8.89507 14.0411 8.66679 14.5922 8.66679 15.1668V23.8335H5.41679C5.12948 23.8335 4.85393 23.7193 4.65076 23.5162C4.4476 23.313 4.33346 23.0375 4.33346 22.7502V8.72532L13.0001 2.42248L21.6668 8.72532V22.7502Z",
    fill: "#344054"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3691_3645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ca2217101a8c5cb5fd9dd2501ba001c1.svg";
export { ForwardRef as ReactComponent };